import React from 'react';
import { motion } from 'motion/react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowUp, Github, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="py-12 relative overflow-hidden border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo & Copyright */}
          <div className="text-center md:text-left">
            <div className="text-2xl font-display font-bold gradient-text mb-2">
              CrisBS<span className="text-white">.</span>
            </div>
            <p className="text-sm text-white/40 font-mono">
              &copy; {new Date().getFullYear()} Cristobal Bello - Personal Web Site . {t('footer.rights')}
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a href="https://github.com/nvidiati" className="text-white/40 hover:text-primary transition-colors">
              <Github className="w-5 h-5" />
            </a>
            <a href="https://www.linkedin.com/in/ing-cristobal-bello/" className="text-white/40 hover:text-primary transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="https://www.instagram.com/khriztopher_bs/" className="text-white/40 hover:text-primary transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
          </div>

          {/* Back to Top */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ y: -5 }}
            whileTap={{ scale: 0.9 }}
            className="w-12 h-12 glass rounded-full flex items-center justify-center group hover:border-primary/50 transition-all"
          >
            <ArrowUp className="w-5 h-5 text-white/40 group-hover:text-primary transition-colors" />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
